import { combineReducers } from 'redux'
import * as TypeAction from './actionTypes'
import { reducerList } from 'scorpion-core';



export default combineReducers({
    rLista: reducerList(TypeAction.LISTAR),

})


// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/reducer.js